import styled from "styled-components";

export default styled.div`
  .react-daterange-picker {
    float: right;
    height: 38px;
    .react-daterange-picker__wrapper {
      border-color: #ced4da;
      .react-daterange-picker__inputGroup > input {
        color: #495057;
      }
    }
  }
`;
